/**
 * Gets the comma-separated brand names of an electronic instruction item.
 *
 * @param {Object} item - Expects an electronic instruction item.
 *
 * @returns {String}
 */
export default function getElectronicInstructionBrandNames(item) {
  const { brandNames } = item || {};

  return Array.isArray(brandNames) ? brandNames.join(', ') : '';
}
